<template>
  <div class="app-container">
    <navigation title="活动预告"></navigation>
    <div class="content">
      <div class="calendar-box">
        <van-calendar
            title=""
            :poppable="false"
            :show-confirm="false"
            :show-mark="false"
            class="date-calendar"
            :formatter="formatter"
            @select="select"
            :min-date="minDate"
            :max-date="maxDate"
            :default-date="null"
            ref="calendar"
        />
<!--        <div class="unfold" v-if="isUnfold" @click="showCalendar">点击展开<van-icon name="arrow-down" /></div>-->
<!--        <div class="unfold" v-else @click="hideCalendar">点击收回<van-icon name="arrow-up" /></div>-->
        <div class="return" @click="returnAll" v-if="isReturn">
          <svg-icon iconClass='refresh' className='refresh'></svg-icon>
          点击查看全部
        </div>
      </div>
      <div class="notice" v-if="lectureList.length>0">
        <van-cell title="讲座预告" is-link :to="{name:'lecture',query:{title:'讲座预告'}}" center class="van-title">
          <template #right-icon>
            <div>
              <span class="more-val">更多</span>
            </div>
          </template>
        </van-cell>
        <van-cell-group>
          <van-cell class="list" v-for="item in lectureList" :to="{name:'exhibitionDetail', query: {id:item.id,title:'讲座详情',introduce:'讲座介绍'}}">
            <template #title>
              <div class="message-tit"><svg-icon  class="trailer-svg" iconClass='trailer-notice' className='refresh'></svg-icon>{{ item.title }}</div>
              <div class="message-tit message-tit-right" v-if="item.subTitle">{{ item.subTitle }}</div>
            </template>
            <template #label>
              <div class="time">
                <img src="@/assets/img/list-news.png" alt="" class="news">
                <span v-if='(item.startTime || "").split(" ")[0]===(item.endTime || "").split(" ")[0]'>{{item.startTime.split(' ').join(' '+item.startWeek+' ')}}-{{(item.endTime || "").split(' ')[1]}}</span>
                <span v-else-if="item.endTime">{{ item.startTime.split(' ').join(' '+item.startWeek+' ') }}—{{ item.endTime.split(' ').join(' '+item.endWeek+' ') }}</span>
                <span v-else>{{ item.startTime.split(' ').join(' '+item.startWeek+' ') }}</span>
              </div>
            </template>
          </van-cell>
        </van-cell-group>
      </div>
      <div class="notice collect"  v-if="exhibitionList.length>0">
        <van-cell title="展览预告" is-link :to="{name:'lecture',query:{title:'展览预告'}}" center class="van-title">
          <template #right-icon>
            <div>
              <span class="more-val">更多</span>
            </div>
          </template>
        </van-cell>
        <van-cell-group>
          <van-cell class="list" v-for="item in exhibitionList" :to="{name:'exhibitionDetail', query: {id:item.id,title:'展览详情',introduce:'展览简介'}}">
            <template #title>
              <div class="message-tit"><svg-icon class="trailer-svg" iconClass='trailer-exhibition' className='refresh'></svg-icon>{{ item.title }}</div>
              <div class="message-tit message-tit-right" v-if="item.subTitle">{{ item.subTitle }}</div>
            </template>
            <template #label>
              <div class="time">
                <span v-if='(item.startTime || "").split(" ")[0]===(item.endTime || "").split(" ")[0]'>{{item.startTime.split(' ').join(' '+item.startWeek+' ')}}-{{(item.endTime || "").split(' ')[1]}}</span>
                <span v-else-if="item.endTime">{{ item.startTime.split(' ').join(' '+item.startWeek+' ') }}—{{ item.endTime.split(' ').join(' '+item.endWeek+' ') }}</span>
                <span v-else>{{ item.startTime+' '+item.startWeek }} 起</span>
              </div>
            </template>
          </van-cell>
        </van-cell-group>
      </div>
      <div class="notice collect" v-if="showList.length>0">
        <van-cell title="演出预告" is-link :to="{name:'lecture',query:{title:'演出预告'}}" center class="van-title">
          <template #right-icon>
            <div>
              <span class="more-val">更多</span>
            </div>
          </template>
        </van-cell>
        <van-cell-group>
          <van-cell class="list" v-for="item in showList" :to="{name:'exhibitionDetail', query: {id:item.id,title:'演出详情',introduce:'演出简介'}}">
            <template #title>
              <div class="message-tit"><svg-icon class="trailer-svg" iconClass='trailer-show' className='refresh'></svg-icon>{{ item.title }}</div>
              <div class="message-tit message-tit-right" v-if="item.subTitle">{{ item.subTitle }}</div>
            </template>
            <template #label>
              <div class="time">
                <img src="@/assets/img/list-news.png" alt="" class="news">
                <span v-if='(item.startTime || "").split(" ")[0]===(item.endTime || "").split(" ")[0]'>{{item.startTime.split(' ').join(' '+item.startWeek+' ')}}-{{(item.endTime || "").split(' ')[1]}}</span>
                <span v-else-if="item.endTime">{{ item.startTime.split(' ').join(' '+item.startWeek+' ') }}—{{ item.endTime.split(' ').join(' '+item.endWeek+' ') }}</span>
                <span v-else>{{ item.startTime.split(' ').join(' '+item.startWeek+' ') }}</span>
              </div>
            </template>
          </van-cell>
        </van-cell-group>
      </div>
      <div class="notice collect" v-if="trainList.length>0">
        <van-cell title="培训预告" is-link :to="{name:'lecture',query:{title:'培训预告'}}" center class="van-title">
          <template #right-icon>
            <div>
              <span class="more-val">更多</span>
            </div>
          </template>
        </van-cell>
        <van-cell-group>
          <van-cell class="list" v-for="item in trainList" :to="{name:'exhibitionDetail', query: {id:item.id,title:'培训详情',introduce:'培训简介'}}">
            <template #title>
              <div class="message-tit"><svg-icon class="trailer-svg" iconClass='trailer-train' className='refresh'></svg-icon>{{ item.title }}</div>
              <div class="message-tit message-tit-right" v-if="item.subTitle">{{ item.subTitle }}</div>
            </template>
            <template #label>
              <div class="time">
                <img src="@/assets/img/list-news.png" alt="" class="news">
                <span v-if='(item.startTime || "").split(" ")[0]===(item.endTime || "").split(" ")[0]'>{{item.startTime.split(' ').join(' '+item.startWeek+' ')}}-{{(item.endTime || "").split(' ')[1]}}</span>
                <span v-else-if="item.endTime">{{ item.startTime.split(' ').join(' '+item.startWeek+' ') }}—{{ item.endTime.split(' ').join(' '+item.endWeek+' ') }}</span>
                <span v-else>{{ item.startTime+' '+item.startWeek }} 起</span>
              </div>
            </template>
          </van-cell>
        </van-cell-group>
      </div>
    </div>
    <scroll></scroll>
    <version></version>
  </div>
</template>

<script>
import Vue from 'vue'
import { Cell, CellGroup, List, Icon, Checkbox, Toast } from 'vant'
import {request} from '../../untils/request'
import {parseTime} from '../../untils/formatTime'
import navigation from '../../components/navigation'
import version from '../../components/version'
import scroll from '../../components/scroll'

Vue.use(Cell).use(CellGroup).use(List).use(Icon).use(Checkbox).use(Toast)
export default {
  name: 'trailer',
  components: {navigation, version, scroll},
  data () {
    return {
      params: {
        pageNum: '1',
        pageSize: '2'
      },
      lectureList: [],
      exhibitionList: [],
      showList: [],
      trainList: [],
      isReturn: false,
      minDate:  new Date(),
      maxDate: new Date(),
      trailerList:'',
      isUnfold: true,
      // divHeight: '2.25rem'
    }
  },
  created () {
    // 讲座预告
    this.getLecture()
    // 展览预告
    this.getExhibition()
    // 演出预告
    this.getShow()
    // 培训预告
    this.getTrain()
    // 获取两月内预告日期
    this.getTrailerDate ()
    // 计算60天以后的日期
    this.getBeforeDate ()
  },
  methods: {
    onClickLeft () {
      this.$router.go(-1)
    },
    getLecture () {
      this.params.noticeType = 'NOTICE_LECTURE'
      request('get', '/nlc-web/api/nlcNotice/page', this.params).then(res => {
        console.log('讲座预告', res)
        for (var i = 0; i < res.data.content.length; i++) {
          res.data.content[i].startTime = parseTime(res.data.content[i].startTime,'{y}-{m}-{d} {h}:{i}')
          res.data.content[i].endTime = parseTime(res.data.content[i].endTime,'{y}-{m}-{d} {h}:{i}')
        }
        this.lectureList = res.data.content
      })
    },
    getExhibition () {
      this.params.noticeType = 'NOTICE_EXHIBITION'
      request('get', '/nlc-web/api/nlcNotice/page', this.params).then(res => {
        console.log('展览预告', res)
        for (var i = 0; i < res.data.content.length; i++) {
          res.data.content[i].startTime = parseTime(res.data.content[i].startTime,'{y}-{m}-{d}')
          res.data.content[i].endTime = parseTime(res.data.content[i].endTime,'{y}-{m}-{d}')
        }
        this.exhibitionList = res.data.content
      })
    },
    getShow () {
      this.params.noticeType = 'NOTICE_SHOW'
      request('get', '/nlc-web/api/nlcNotice/page', this.params).then(res => {
        console.log('演出预告', res)
        for (var i = 0; i < res.data.content.length; i++) {
          res.data.content[i].startTime = parseTime(res.data.content[i].startTime,'{y}-{m}-{d} {h}:{i}')
          res.data.content[i].endTime = parseTime(res.data.content[i].endTime,'{y}-{m}-{d} {h}:{i}')
        }
        this.showList = res.data.content
      })
    },
    getTrain () {
      this.params.noticeType = 'NOTICE_TRAIN'
      request('get', '/nlc-web/api/nlcNotice/page', this.params).then(res => {
        console.log('培训预告', res)
        for (var i = 0; i < res.data.content.length; i++) {
          res.data.content[i].startTime = parseTime(res.data.content[i].startTime,'{y}-{m}-{d}')
          res.data.content[i].endTime = parseTime(res.data.content[i].endTime,'{y}-{m}-{d}')
        }
        this.trainList = res.data.content
      })
    },
    // 自定义日期文案
    formatter(day) {
      const month = day.date.getMonth() + 1
      const date = day.date.getDate()
      for (let i=0;i<this.trailerList.length;i++) {
        if (month === Number(this.trailerList[i].split('-')[1])) {
          if (date === Number(this.trailerList[i].split('-')[2])) {
            day.topInfo = '1';
          }
        }
      }
      return day;
    },
    // 切换日期
    select (value) {
      this.isReturn = true // 显示点击返回全部
      this.params.noticeTime = parseTime(value,'{y}-{m}-{d}')
      delete this.params.noticeType
      request('get', '/nlc-web/api/nlcNotice/group', this.params).then(res => {
        console.log('预告列表', res)
        for (var i = 0; i < res.data.NOTICE_LECTURE.content.length; i++) {
          res.data.NOTICE_LECTURE.content[i].startTime = parseTime(res.data.NOTICE_LECTURE.content[i].startTime,'{y}-{m}-{d} {h}:{i}')
          res.data.NOTICE_LECTURE.content[i].endTime = parseTime(res.data.NOTICE_LECTURE.content[i].endTime,'{y}-{m}-{d} {h}:{i}')
        }
        for (var i = 0; i < res.data.NOTICE_EXHIBITION.content.length; i++) {
          res.data.NOTICE_EXHIBITION.content[i].startTime = parseTime(res.data.NOTICE_EXHIBITION.content[i].startTime,'{y}-{m}-{d}')
          res.data.NOTICE_EXHIBITION.content[i].endTime = parseTime(res.data.NOTICE_EXHIBITION.content[i].endTime,'{y}-{m}-{d}')
        }
        for (var i = 0; i < res.data.NOTICE_SHOW.content.length; i++) {
          res.data.NOTICE_SHOW.content[i].startTime = parseTime(res.data.NOTICE_SHOW.content[i].startTime,'{y}-{m}-{d} {h}:{i}')
          res.data.NOTICE_SHOW.content[i].endTime = parseTime(res.data.NOTICE_SHOW.content[i].endTime,'{y}-{m}-{d} {h}:{i}')
        }
        for (var i = 0; i < res.data.NOTICE_TRAIN.content.length; i++) {
          res.data.NOTICE_TRAIN.content[i].startTime = parseTime(res.data.NOTICE_TRAIN.content[i].startTime,'{y}-{m}-{d} {h}:{i}')
          res.data.NOTICE_TRAIN.content[i].endTime = parseTime(res.data.NOTICE_TRAIN.content[i].endTime,'{y}-{m}-{d} {h}:{i}')
        }
        this.lectureList = res.data.NOTICE_LECTURE.content // 讲座
        this.exhibitionList = res.data.NOTICE_EXHIBITION.content //展览
        this.showList = res.data.NOTICE_SHOW.content // 演出
        this.trainList = res.data.NOTICE_TRAIN.content // 培训
        if(this.lectureList.length===0 && this.exhibitionList.length===0 && this.showList.length===0 && this.trainList.length==0){
          Toast('暂无预告信息')
        }
      })
    },
    // 点击返回全部
    returnAll () {
      location.reload()
    },
    //
    getBeforeDate () {
      var newDate = new Date();
      var befminuts = newDate.getTime() + 1000 * 60 * 60 * 24 * parseInt(60);
      var beforeDat = new Date;
      beforeDat.setTime(befminuts);
      var befMonth = beforeDat.getMonth() + 1;
      var mon = befMonth >= 10 ? befMonth : '0' + befMonth;
      var befDate = beforeDat.getDate();
      var da = befDate >= 10 ? befDate : '0' + befDate;
      this.maxDate = new Date(beforeDat.getFullYear(),mon-1,da)
    },
    // 获取两月内预告日期
    getTrailerDate () {
      request('get', '/nlc-web/api/nlcNotice/findFutureDate').then(res => {
        console.log('两月内预告日期', res)
        this.trailerList = res.data
      })
    },
    // // 展开
    // showCalendar () {
    //   this.isUnfold = false
    //   this.divHeight = `${5.44}rem`
    // },
    // //收起
    // hideCalendar() {
    //   this.isUnfold = true
    //   this.divHeight = `${2.25}rem`
    // }
  }
}
</script>

<style scoped>
.app-container{
  min-height:100%;
  background:#ecf5fd;
  overflow-y:scroll;
}
.content{
  width: 6.94rem;
  margin:1.18rem .28rem .16rem .28rem;
}
.notice{
  border-radius:8px;
  background:#fff;
}
.more{
  width:.13rem;
  height:.24rem;
  vertical-align: middle;
}
.more-val{
  width:.66rem;
  display:inline-block;
  font-size:.24rem;
  font-family: SourceHanSansCN-Regular;
  line-height: .24rem;
  vertical-align: middle;
}
.van-cell--clickable{
  padding:.4rem .26rem .1rem .26rem;
  border-radius:8px;
  height:1rem;
}
.van-cell--clickable::after{
  border:0 !important;
}
.van-hairline--top-bottom::after, .van-hairline-unset--top-bottom::after{
  border-width: 0;
}
.time{
  margin-top:.2rem;
  border-bottom:1px solid #DCE5ED;
  padding-bottom:.19rem;
  font-size:.22rem;
  font-family: -apple-system,BlinkMacSystemFont,'Helvetica Neue',Helvetica,Segoe UI,Arial,Roboto,
  'PingFang SC',miui,'Hiragino Sans GB','Microsoft Yahei',sans-serif;
}
.time span{
  vertical-align: middle;
}
.van-cell-group:last-child .time{
  border-bottom:0;
}
.collect{
  margin-top:.16rem;
}
.van-title {
  font-size:.36rem;
  font-family: SourceHanSerifCN-SemiBold;
}
/*.van-cell--clickable{*/
/*  background:url(../../assets/img/title-bg.png) no-repeat 0 .2rem;*/
/*  background-size:25%;*/
/*}*/
.van-cell::after{
  border-bottom: 1px solid #B3BBC3;
}
.calendar-box{
  margin-bottom: .16rem;
  background: #fff;
  border-radius:8px;
}
.date-calendar{
  height:5.5rem;
  background-size:100%;
  border-radius:8px;
}
.calendar-tip{
  width: 6.59rem;
  height: 1rem;
  background: url("../../assets/img/tip-bg.png") no-repeat;
  background-size:100%;
  border-radius: 0px 0px 36px 36px;
  margin-left:.17rem;
  font-size:.24rem;
  color:#008095;
  display:flex;
  padding-top:.18rem;
}
.checked{
  margin:0 .8rem 0 .62rem;
}
.checked span{
  width:.62rem;
  height:.62rem;
  display:inline-block;
  border-radius:8px;
  border: 2px solid rgba(0, 128, 149, 0.5);
  vertical-align:middle;
  margin-right:.19rem;
}
.checked span i{
  width:.32rem;
  height:.32rem;
  margin:.14rem;
  display:inline-block;
  background: linear-gradient(54deg, #D2F9FF 0%, #048297 77%, #008095 100%, #008095 100%);
  box-shadow: 3px 10px 10px 0px rgba(21, 140, 160, 0.2);
  border-radius:50%;
}
.trailer-tip span{
  width:.62rem;
  height:.62rem;
  display:inline-block;
  border-radius:8px;
  border: 2px solid rgba(0, 128, 149, 0.5);
  vertical-align:middle;
  margin-right:.19rem;
}
.trailer-tip span i{
  width:.08rem;
  height:.08rem;
  margin:.28rem;
  display:inline-block;
  border-radius:8px;
  background: linear-gradient(153deg, #FFD78B 0%, #7E6027 100%);
  box-shadow: 1px 3px 4px 0px rgba(0, 0, 0, 0.2);
}
.return{
  /*color:#008095;*/
  font-size:.24rem;
  text-align:center;
  padding:.16rem 0;
}
.return img{
  width:.19rem;
  height:.17rem;
  vertical-align: middle;
}
>>>.van-calendar__header-title{
  display:none;
}
>>>.van-calendar__day{
  height: 39px;
  font-size: 12px;
}
>>>.van-calendar__selected-day{
  width:.44rem;
  height:.44rem;
  background: linear-gradient(54deg, #D2F9FF 0%, #048297 77%, #008095 100%, #008095 100%);
  border-radius:50%;
}
>>>.van-calendar__top-info{
  background: linear-gradient(153deg, #FFD78B 0%, #7E6027 100%);
  width:.08rem;
  height:.08rem;
  border-radius:50%;
  left: .44rem;
  top:27px;
  color:#fff;
  line-height:.4rem;
  overflow: hidden;
}
.list >>>.van-cell__title{
  width:100%;
  font-size:.3rem;
  font-family: SourceHanSerifCN-Regular;
  line-height:.4rem;
}
.list{
  padding:.1rem .27rem !important;
}
>>>.van-cell,>>>.van-cell-group{
  border-radius:16px;
}
.news{
  width:.45rem;
  height:.25rem;
  margin-right: .1rem;
  vertical-align: middle;
}
.unfold{
  width:100%;
  padding:.17rem 0;
  text-align:center;
  color:#94979C;
  font-size:.2rem;
  background:#fff;
  border-radius:8px;
}
.message-tit{
  width:100%;
  overflow: hidden;
  text-overflow:ellipsis;
  white-space: nowrap;
  word-wrap:break-word;
}
.message-tit-right{
  text-align:right;
}
.trailer-svg{
  margin-right:.1rem;
}
</style>



// WEBPACK FOOTER //
// src/view/trailer/index.vue